
import React, { useState, useEffect } from 'react';
import { Download, X, Smartphone, Monitor } from 'lucide-react';

export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}

interface PwaHandlerProps {
  isStandalone: boolean;
  canInstall: boolean;
  onInstall: () => void;
}

const PwaHandler: React.FC<PwaHandlerProps> = ({ isStandalone, canInstall, onInstall }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (isStandalone || !canInstall || !isVisible) return null;

  return (
    <div className="fixed bottom-24 left-4 right-4 md:left-8 md:right-auto md:bottom-8 z-[2000] animate-fade-in-up max-w-sm w-full">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 md:p-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 shrink-0">
            <Smartphone className="md:hidden" size={20} />
            <Monitor className="hidden md:block" size={20} />
          </div>
          <div className="min-w-0">
            <h3 className="text-xs font-bold text-gray-900 leading-tight truncate">Instalar Aplicativo</h3>
            <p className="text-[10px] text-gray-500 font-medium uppercase tracking-wider mt-0.5">Navegação nativa rápida</p>
          </div>
        </div>
        
        <div className="flex items-center gap-2 shrink-0">
          <button 
            onClick={onInstall}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1.5 rounded-xl text-[10px] font-bold uppercase tracking-wider transition-all shadow-md active:scale-95 flex items-center gap-1.5 whitespace-nowrap"
          >
            <Download size={12} /> Instalar
          </button>
          <button 
            onClick={() => setIsVisible(false)}
            className="p-1.5 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PwaHandler;
